import { render, staticRenderFns } from "./CourseTakeButtons.vue?vue&type=template&id=431388f6&"
import script from "./CourseTakeButtons.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseTakeButtons.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports